import styled from '@emotion/styled';

export const ProviderDetailsContainer = styled.div`
  background: ${({ theme }) => theme.palette.background.default};
  padding-bottom: 40px;
  @media screen and (max-width: 600px) {
    background-color: transparent;
  }
`;
